'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const Smartsupp = () => {
  const pathname = usePathname();
  const [shouldShowScript, setShouldShowScript] = useState(true);

  useEffect(() => {
    let isExcludedPage =
      pathname?.includes('/logowanie') || pathname?.includes('/zamowienie');
    setShouldShowScript(!isExcludedPage);
  }, [pathname]);

  useEffect(() => {
    const styleId = 'custom-smartsupp-style';
    //let styleSheet = document.getElementById(styleId) as HTMLStyleElement;
    let styleSheet = document.getElementById(styleId);

    if (!shouldShowScript) {
      if (!styleSheet) {
        styleSheet = document.createElement('style');
        styleSheet.id = styleId;
        styleSheet.innerHTML = `
          div#smartsupp-widget-container {
            display: none !important;
          }
        `;
        document.head.appendChild(styleSheet);
      }
    } else {
      if (styleSheet) {
        styleSheet.remove();
      }
    }
  }, [shouldShowScript]);

  return (
    <Script
      id="smartsupp-widget-container"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
                var _smartsupp = _smartsupp || {};
_smartsupp.key = 'e1fa2f4e0aa0459b43ec214d5cc54205ba8fade2';
window.smartsupp||(function(d) {
  var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];
  s=d.getElementsByTagName('script')[0];c=d.createElement('script');
  c.type='text/javascript';c.charset='utf-8';c.async=true;
  c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);
})(document);`,
      }}
    />
  );
};

export default Smartsupp;
